import {userStore} from "@/store/user";
import {familyStore} from "@/store/family";
import {doumiStore} from "@/store/doumi";
import {configStore} from "@/store/config";
import {createPinia} from "pinia";

const stores = {
    userStore,familyStore,doumiStore,configStore
};

const pinia = createPinia()
for(const store in stores) {
    //pinia.use(store)
}

export {
    pinia
};

export default stores;
